/**
 * Must match the CHECK constraint on products.category (and template_products.category).
 * No i18n here — this app is English-only.
 */
export const PRODUCT_CATEGORIES = [
  "juice",
  "puff",
  "device",
  "kit",
  "pod",
  "coil",
  "cotton",
  "accessory",
].map((value) => ({ value, label: value }));
